import { render } from "./BaseViewHeaderBtn.vue?vue&type=template&id=7627e5d4"
import script from "./BaseViewHeaderBtn.vue?vue&type=script&lang=js"
export * from "./BaseViewHeaderBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__